import { apiService, createRequestHeadersConfig } from 'shared/api'

import {
  DeliverySlot,
  DeliverySlotResponse,
  FirstAvailableDeliverySlotResponse,
  FirstAvailableTmsDeliverySlotResponse,
  TMSDeliverySlotData,
  TMSDeliverySlotResponse,
  TMSTimeSlot
} from './types'

const api = apiService()

export const getFirstAvailableDeliverySlot = async (
  deliveryMethodId: string,
  token: string
): Promise<DeliverySlot | null> => {
  const result: FirstAvailableDeliverySlotResponse = await api.get(
    `/deliveries/${deliveryMethodId}/first-available-slot`,
    createRequestHeadersConfig(token)
  )

  const timeSlot: DeliverySlot | null = result?.data?.data || null

  return timeSlot
}

export const getFirstAvailableTmsDeliverySlot = async (
  cartId: string,
  token: string
) => {
  const result: FirstAvailableTmsDeliverySlotResponse = await api.get(
    `/deliveries-tms/slots/first/${cartId}`,
    createRequestHeadersConfig(token)
  )
  const timeSlot: TMSTimeSlot | null = result?.data?.data || null

  return timeSlot
}

export const getTMSDeliverySlots = async ({
  cartId,
  date,
  token
}: {
  cartId: string
  date: string
  token?: string
}): Promise<TMSDeliverySlotData | null> => {
  try {
    const result: TMSDeliverySlotResponse = await api.get(
      `/deliveries-tms/slots/${cartId}/${date}`,
      createRequestHeadersConfig(token)
    )

    return result?.data.data || null
  } catch (err) {
    console.error(err)

    return null
  }
}

interface GetDeliverySlotsByDeliveryMethodIdServicePayload {
  deliveryMethodId: string
  token?: string
}

export const getDeliverySlotsByDeliveryMethodIdService = async ({
  deliveryMethodId,
  token
}: GetDeliverySlotsByDeliveryMethodIdServicePayload) => {
  try {
    const result: DeliverySlotResponse = await api.get(
      `/deliveries/${deliveryMethodId}/slots`,
      createRequestHeadersConfig(token)
    )

    return result?.data?.data || null
  } catch (err) {
    console.error(err)

    return null
  }
}
